// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"12b95afa","149":"4fa1585b","189":"369e7f2f","424":"3ca03911","490":"1a6da709","518":"ff53cb03","667":"6f5dfa39","781":"fbbec1bc","872":"7cc04ff3"}[chunkId] + ".chunk.js";
};